import { createContext, useCallback, useEffect, useState } from 'react';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { doc, initializeFirestore, onSnapshot } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { BACKEND_URL } from '../Config';

const firebaseConfig = {
    apiKey: "AIzaSyAx_yD-A6zSTr9rCyDOqd7pzvYFI8BxmfU",
    authDomain: "echoagent-115c0.firebaseapp.com",
    projectId: "echoagent-115c0",
    storageBucket: "echoagent-115c0.firebasestorage.app",
    messagingSenderId: "901908833821",
    appId: "1:901908833821:web:adbd623124de0d08b9c8f4"
};

export const AppContext = createContext()

export const AppContextProvider = props => {

    /***************************
        AUTH & FIRESTORE
    ****************************/
    const app = initializeApp(firebaseConfig);
    if (firebaseConfig.measurementId)
        getAnalytics(app);
    const firebaseDB = initializeFirestore(app, { experimentalAutoDetectLongPolling: true });

    const [user, setUser] = useState()
    const [error, setError] = useState()
    const [userCollection, setUserCollection] = useState();
    const [currentAgentUID, setCurrentAgentUID] = useState();
    const [agentServerData, setAgentServerData] = useState(undefined);

    const setUserWrapper = async (userVal) => setUser(userVal);

    useEffect(() => {

        if (!firebaseDB) return;

        const authStateChangeWrapper = async (userVal) => {
            //retrieve firestore snapshot result first becore setting user state, this is important for routes in App.js
            let unsubFromUserCollection = null;

            if (userVal) {
                setUserCollection(undefined); //reset required to solve a short view of onboarding everytime user opens the app
                setUserWrapper(userVal);

                unsubFromUserCollection = onSnapshot(doc(firebaseDB, "userCollection", userVal.uid), async (userDoc) => {
                    if (userDoc.data() && Object.keys(userDoc.data())?.length) {
                        console.log("OnSnapShot userDoc update", userDoc.data())
                        setUserCollection(userDoc.data())
                    } else {
                        setUserCollection(null);
                        console.log("OnSnapShot userDoc update NULL")
                    }

                });
            } else if (userVal === null) { //means firebase checked & states that user is not logged in
                setUserCollection(null); //move the state from undefined so that Auth/Onboarding/UnAuth routes work
                setUserWrapper(userVal);
            }

            return () => {
                if (unsubFromUserCollection) unsubFromUserCollection();
            } //unsubscribe when component is unmounted
        }

        const unsubscribe = onAuthStateChanged(getAuth(), authStateChangeWrapper, setError)
        //const unsubscribe2 = onIdTokenChanged(getAuth(), async (userVal) => setAccessToken(userVal ? await userVal.getIdToken() : null), setError); //accesstoken shouldn't be used anyware anymore
        return () => { unsubscribe(); } //unsubscribe when component is unmounted

    }, [firebaseDB])

    const backendApiCall = useCallback(async (path, body, cache, forceTokenUpdate) => { //for some functions it is critical have latest accessToken as they are called at app start and token might have expired by then. Not important for all functions
        if (!user)
            return false;
        const accessToken = await user?.getIdToken(forceTokenUpdate ? true : false);
        const resp = await fetch(`${BACKEND_URL}${path}`, {
            method: 'POST', cache: cache || 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify({ ...body })
        });
        return resp
    }, [user])

    useEffect(() => {
        const fetchAgents = async () => {
            try {
                const resp = await backendApiCall(`/dashboard/get-agentuids`, {})
                if(resp === false)
                    return;
                const respJson = await resp.json();
                console.log("fetchAgents res: ", respJson)

                if (!resp.ok)
                    throw Error("server error")
                setAgentServerData(respJson)
                setCurrentAgentUID(respJson.agentInfo.agentUID)
            } catch (e) {
                setAgentServerData(null)
                setCurrentAgentUID(null)
                console.log("fetchAgents - error: ", e)
            }
        }
        if (agentServerData === undefined)
            fetchAgents()
    }, [backendApiCall, agentServerData])

    return <AppContext.Provider value={{
        firebaseDB,
        user, error, userCollection,
        backendApiCall,
        currentAgentUID, setCurrentAgentUID, agentServerData
    }} {...props} />
}